import { Mask } from '@react-three/drei';
import { useMemo, VoidFunctionComponent } from 'react';
import { Shape } from 'three';

interface Props {
    width: number;
    height: number;
}

export const PortalMask: VoidFunctionComponent<Props> = ({ width, height }) => {
    const shape = useMemo(() => {
        const w = width * 0.99;
        const h = height * 0.99;

        const mask = new Shape();
        const radius = 0.18;
        const left = -w / 2;
        const right = w / 2;
        const bottom = -h / 2;
        const top = h / 2;
        mask.moveTo(left, bottom + radius);
        mask.lineTo(left, top - radius);
        mask.quadraticCurveTo(left, top, left + radius, top);
        mask.lineTo(right - radius, top);
        mask.quadraticCurveTo(right, top, right, top - radius);
        mask.lineTo(right, bottom + radius);
        mask.quadraticCurveTo(right, bottom, right - radius, bottom);
        mask.lineTo(left + radius, bottom);
        mask.quadraticCurveTo(left, bottom, left, bottom + radius);
        return mask;
    }, [width, height]);

    return (
        <Mask id={1} depthWrite={false}>
            <shapeGeometry attach="geometry" args={[shape]} />
        </Mask>
    );
};
